<template>
  <div>
    <img class="base-image" :class="styleImage" :src="image" />
  </div>
</template>
<script>
  export default {
    props: {
      image: {
        type: String,
        required: true
      },
      styleImage: {
        type: String,
      }
    }
  }
</script>
